import {
  ComplianceControlAssets,
  ComplianceControlAssetsProps,
} from "~/pages/compliance/Control/ControlOutlets";

const FrameworkControlAssetsEntryPage = ({}: ComplianceControlAssetsProps) => {
  return <ComplianceControlAssets />;
};

export default FrameworkControlAssetsEntryPage;
